import { network } from 'services/network';

export const resendInviteEmail = (params) => {
    const url = `admin/bo/resendInviteEmail?userEmail=${encodeURIComponent(params)}`;
    return network
        .post(url)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            if (error === 'Request failed with status code 404') {
                throw new Error('invalid email!');
            } else {
                throw error;
            }
        });
};
